import { ContactFilters } from "@/types/filters/contact";
import { ColumnFiltersState } from "@tanstack/react-table";

export const stateToFilter = (filters: ColumnFiltersState | undefined) => {
  if (!filters || filters.length === 0) return undefined;

  const result = Object.fromEntries(
    filters
      .map((filter) => {
        let value: string;
        if (Array.isArray(filter['value'])) {
          value = filter['value'].join(',')
        } else {
          value = String(filter['value'])
        }
        return [filter['id'], value]
      })
  )

  return { ...result, pageIndex: undefined };
};

export const filterToState = (filters: ContactFilters | undefined) => {
  if (!filters) return [];

  const omitSortBy = ([key]: [string, unknown]) => key !== 'sortBy';
  const state = Object.entries(filters).filter(omitSortBy).map(([key, value]) => {
    const stringValue = String(value);
    return {
      id: key,
      value: /,/g.test(stringValue) ? stringValue.split(',') : stringValue
    }
  })
  return state;
};
